import React from "react";
import ContactForm from "./ContactForm";
import InfoSection from "./InfoSection";
import classes from "./page-body.module.css";

const PageBody = () => {
  return (
    <div>
      <div className={classes.container}>
        <InfoSection />
        <ContactForm />
      </div>
    </div>
  );
};

export default PageBody;
